import { css, html, LitElement } from "lit";
import { customElement } from "lit/decorators.js";
import * as Styles from "../../styles.ts";

const styles = css`
  :host {
    --chat-narrow-width: 30rem;
    display: block;
    width: 100cqw;
    height: 100cqh;
    container-type: size;
  }

  .chat-view {
    display: flex;
    width: 100cqw;
    height: 100cqh;
  }

  .chat-view-chat {
    flex: 1;
    min-width: 0;
    container-type: size;
    overflow: hidden;
    height: 100%;
  }

  .chat-view-canvas {
    position: relative;
    width: 0;
    height: 100%;
    flex-shrink: 0;
    overflow: hidden;
    transition: width var(--duration-normal) var(--ease-out-3);
  }

  :host([show-canvas]) .chat-view-canvas {
    width: calc(100cqw - var(--chat-narrow-width));
  }

  .chat-view-canvas-inner {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    width: calc(100cqw - var(--chat-narrow-width));
    container-type: size;
  }
`;

/**
 * A chat view component that displays a chat area and an optional canvas area.
 *
 * @element chat-view
 *
 * @slot - The default slot for chat content
 * @slot canvas - Slot for canvas content (displayed when show-canvas attribute is set)
 *
 * @attr {boolean} show-canvas - When present, displays the canvas area alongside the chat
 *
 * @cssprop --chat-narrow-width - Width of the chat area when canvas is shown.
 */
@customElement("chat-view")
export class ChatViewElement extends LitElement {
  static override styles = [Styles.base, styles];

  override render() {
    return html`
      <div class="chat-view">
        <div class="chat-view-chat">
          <slot></slot>
        </div>
        <div class="chat-view-canvas">
          <div class="chat-view-canvas-inner">
            <slot name="canvas"></slot>
          </div>
        </div>
      </div>
    `;
  }
}
